<template>
  <div class="report">
    <div class="table">
      <el-row type="flex" align="middle" v-if="reportTable">
        <el-col :span="24">
          <table border v-for="(item, i) in reportTable" :key="i">
            <tbody>
              <tr rowspan="8" class="th">
                <td rowspan="8" style="width: 130px; background: white">
                  <div class="px">
                    平行志愿{{ i + 1 + level * 6 }}
                  </div>
                  <div v-if="item.name == '暂无'">
                  </div>
                  <div v-else>
                    <div class="fc" v-if="item.tiaoji">服从调剂</div>
                    <div class="fc" v-else style="color: red">拒绝调剂</div>
                  </div>
                </td>
                <td colspan="7">
                  <span class="name">{{ item.name }}</span>
                  <span>{{ item.group_name }}</span>
                  <span>所在地：{{ item.city_name }} </span>
                  <span>招生代号：{{ item.school_id }} </span>
                  <span>院校计划：{{ item.plan_num }} </span>
                  <span>录取规则：{{ item.lqgz }}</span>
                  <span>选科要求：{{ item.demand }}</span>
                </td>
              </tr>
              <tr>
                <td class="th" style="width: 100px">专业序号</td>
                <td class="th">专业代号/名称</td>
                <td class="th" style="width: 300px">专业详情</td>
                <td class="th" style="width: 100px">专业计划</td>
                <td class="th" style="width: 100px">学费标准</td>
              </tr>
              <tr v-for="(val, key) in record.specialty[i + level * 6]" :key="key" draggable="true">
                <td class="td-height">{{ val.specialty_id }} </td>
                <td class="td-height">{{ val.specialty_name }} </td>
                <td class="td-height">{{ val.remarks }}</td>
                <td class="td-height">{{ val.plan_num }}</td>
                <td class="td-height">{{ val.tuition }}</td>
              </tr>

              <tr v-for="test in 6 - record.specialty[i + level * 6].length" :key="test + i + 'dfd'">
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" v-if="!reportTable">
        <el-col :span="24">
          <div style="margin-top: 20px; text-align: center;"> 暂无志愿表</div>
        </el-col>
      </el-row>
    </div>

    <div class="fenxi" @click="reportFenxi()">
      开始分析
    </div>
  </div>
</template>

<script>
import drag from "../../../utils/drag";
import { mapState } from "vuex";
export default {
  name: '',
  computed: {
    ...mapState(["userInfo"]),
  },
  directives: { drag },
  data() {
    return {
      new_batch: 1,
      level: 0,
      record: {

      },
      oldLine: {},
      reportTable: {},
      len: 48,
      dialogVisible: false,
      paixudialogVisible: false,
      collegeData: null,

      list: [
        { id: 1, name: 'Item 1' },
        { id: 2, name: 'Item 2' },
        { id: 3, name: 'Item 3' },
      ],
      draggedIndex: null,
    };
  },
  watch: {
    new_batch() {
      this.getReport()
    }
  },
  created() {
    // 个人信息
    if (!this.userInfo) {
      console.log('error')
      return false
    }
    this.getReport()
  },
  methods: {
    getReport() {
      let data = {
        user_id: this.userInfo.id,
        subject: this.userInfo.subject,
        new_batch: this.new_batch,
      }
      this.$fecth.post("volunteer/getUserReport", data).then((res) => {

        if (res.record) {
          this.record = JSON.parse(res.record)
          console.log(this.record)
          this.reportTable = this.record.table.slice(0, 48)

        } else {
          this.record = []
          this.reportTable = null
        }
      })
    },
    reportFenxi() {
      let data = {
        title: '这是我填好的一份志愿列表请结合我的信息帮我综合分析下是否有什么问题？',
        user_id: this.userInfo.id,
        subject: this.userInfo.subject,
        new_batch: this.new_batch,
        type: 6
      }
      this.$emit('getChat', data)
    }
  },
};
</script>

<style scoped lang='less'>
.report {
  width: 1200px;
  margin: 0 auto;
  background: white;
}

.filter {
  padding: 0 12px;
  margin-top: 15px;

  ul {
    display: inline-block;
    list-style: none;
    position: relative;
    top: 7px;
  }

  li {
    float: left;
    width: 60px;
    text-align: center;
    margin-left: 20px;
    border: 1px solid #707070;
    border-radius: 19px;
    padding: 2px 7px;
  }

  li:hover {
    background: #459df6;
    color: white;
    border: #459df6;
    border: 1px solid #459df6;
  }

  .level {
    background: #459df6;
    color: white;
    border: #459df6;
    border: 1px solid #459df6;
  }
}

.top {
  margin-top: 20px;
  border-bottom: 4px solid #459EFF;
  height: 40px;
}

.right {
  float: right;
  height: 36px;

  ul {
    display: inline-block;
    list-style: none;
  }

  li {
    float: left;
    margin-left: 10px;
    height: 36px;
    padding: 17px;
    line-height: 3px;
    border-radius: 5px 5px 0 0;
  }

  li:hover {
    color: white;
    background: #459EFF;
    border-bottom: 1px solid #459EFF;
  }

}

.table {
  margin: 0 auto;

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;
    border: 1px solid #dddddd;
    margin-bottom: 10px;

    .th {
      font-size: 16px;
      background: #f4f7fc;
      line-height: 35px;

      .name {
        font-size: 18px;
        font-weight: bold;
      }

      span {
        margin-right: 15px;
      }

      .col {
        margin-left: 0;
        color: #459df6;
      }
    }

    .th,
    td {
      line-height: 35px;
      padding: 5px 13px;
    }
  }

  .del {
    text-align: center;
    margin-bottom: 10px;
  }

  .huanwei {
    text-align: center;
    margin-bottom: 10px;
  }
}

.px {
  margin-top: 20px;
  text-align: center;
  font-size: 14;
  margin-bottom: 10px;
}

.fc {
  text-align: center;
  color: #459df6;
  margin-bottom: 10px;
}
</style>


<style lang="less">
.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.popover-f {
  width: 350px;
  color: black;
  min-width: 0;

  .box-title {
    color: #459df5;
    padding-bottom: 10px;
    border-bottom: 1px solid white;
  }

  .box-item {
    display: inline-block;
  }

  .box-item-box {
    display: inline-block;
    font-size: 14px;
    color: #707070;
    border-radius: 3px;
    background: #daedfc;
    margin: 3px 3px;
    width: 30px;
    line-height: 30px;
    height: 30px;
    text-align: center;
    border: 1px solid #daedfc;
  }

  .box-item-box:hover {
    display: inline-block;
    color: #459df5;
    background: white;
    border: 1px solid #459df5;
  }
}

.paixu {
  background: #f4f7fc;
  padding: 30px 40px;
  width: 1200px;
  margin-bottom: 20px;

  div {
    display: inline-block;
    text-align: center;
  }
}

.fenxi {
  position: fixed;
  right: 130px;
  top: 280px;
  color: white;
  width: 75px;
  height: 75px;
  border-radius: 18px;
  opacity: 1;

  background: linear-gradient(331deg, #0093FF 34%, #003CFF 150%);

  box-sizing: border-box;
  border: 0px solid #F2F2F2;

  box-shadow: 0px 4px 10px 0px rgba(0, 147, 255, 0.55);
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0em;
  padding: 14px 16px 10px 20px;

}
</style>